export enum EmploymentField {
  EMPLOYMENT_STATUS = 'employmentStatus',
  OCCUPATION = 'occupation',
}
